import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '../../services/translate.service';
import { Translation } from '../../models/Translation';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { LoadingSpinnerComponent } from './loading-spinner-component';
import { SnackbarService } from '../../services/snackbar.service';
import {ActionButtonComponent} from '../buttons/action-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, CircleButtonComponent, LoadingSpinnerComponent, ActionButtonComponent],
  selector: 'app-confirm-lang-dialog',
  template: `
    <div class="p-6">
      <div class="flex flex-col items-center">
        <div class="text-2xl font-bold mb-4">{{lang.flag}} {{lang.name}}</div>

        <div class="bg-theme-surface-alt rounded-xl py-2 mb-6">
          <div *ngIf="isWorking" class="flex justify-center py-6">
            <app-loading-spinner></app-loading-spinner>
          </div>
          <div *ngIf="!isWorking" class="text-theme-text">
            {{alert}}
          </div>
        </div>

        <div class="flex justify-between w-full gap-4 mt-4" *ngIf="!buttonText">
          <app-circle-button icon="fa-close" size="12" type="solid" fontSize="xl" (onClick)="close()"></app-circle-button>
          <app-circle-button [disabled]="isWorking" icon="fa-check" size="12" type="solid" fontSize="xl" (onClick)="selectLang()"></app-circle-button>
        </div>
        <div class="mt-4" *ngIf="buttonText && !isWorking">
          <app-action-button text="{{lang?.flag}}&nbsp;&nbsp;{{buttonText}}" (onClick)="selectLang()" [chevron]="true"></app-action-button>
        </div>
      </div>
    </div>
  `
})
export class ConfirmLangDialogComponent implements OnInit {
  @Input() lang: any;
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<any>();
  @Input() buttonText?: string;

  isWorking = true;
  alert = "";

  constructor(
    private translate: TranslateService,
    private snackbar: SnackbarService
  ) {}

  ngOnInit(): void {
    console.log("ConfirmLangDialogComponent initialized with lang:", this.lang);
    this.isWorking = true;
    this.translate.observeAlert(this.lang.code).subscribe((res: Translation) => {
      this.isWorking = false;
      this.alert = res.translation;
    }, error => {
      this.isWorking = false;
      this.snackbar.showMessage("Some error happened :(", 3000);
    });
  }

  close(): void {
    this.onClose.emit();
  }

  selectLang() {
    this.isWorking = true;
    this.alert = "";
    this.translate.prepareLangTranslation(this.lang.code).subscribe(res => {
      if (res) {
        this.onConfirm.emit(this.lang);
      }
    }, error => {
      this.isWorking = false;
      this.snackbar.showMessage("Some error happened :(", 3000);
    });
  }
}
